export default __webpack_public_path__ + "static/media/user.17257b8d.svg";